import { withPayloadType } from 'utils';
import { createAction } from '@reduxjs/toolkit';

export const listTemplatesStart = createAction(
  'LIST_TEMPLATES::START',
  withPayloadType<{ organizationId: string }>(),
);
